import { render } from "./CookiesCatalogItemCard.vue?vue&type=template&id=7120028d&scoped=true&ts=true"
import script from "./CookiesCatalogItemCard.vue?vue&type=script&lang=ts"
export * from "./CookiesCatalogItemCard.vue?vue&type=script&lang=ts"

import "./CookiesCatalogItemCard.vue?vue&type=style&index=0&id=7120028d&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7120028d"]])

export default __exports__